import { useGetCarRoute } from "../Api/Services/useGetCarRoute"
import { useGetCarRouteHash } from "../Api/Services/useGetCarRouteHash"

const fetchCarRouteHash = (carId: number) => {
    return useGetCarRouteHash(carId)
}

const fetchCarRoute = async (token: string) => {
    try {
        const carRouteResponse = await useGetCarRoute(token);
    
        const carRoute = { path: [], parkings: [] };
        carRouteResponse.path.forEach((carRouteResponseItem) => {
            carRoute.path.push([carRouteResponseItem.latitude, carRouteResponseItem.longitude, carRouteResponseItem.dateTime]);
        });
        carRouteResponse.parkings.forEach((carRouteResponseItem) => {
            carRoute.parkings.push({ parking: carRouteResponseItem.parking });
        });
        return carRoute;
    } catch (error) {
        return undefined;
    }
    
}


export {
    fetchCarRouteHash,
    fetchCarRoute
}


// WEBPACK FOOTER //
// ./src/Modules/CarRouteViewer/Services/CarRouteViewer.Service.ts